import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchData, {
  CreateEntry,
  UpdateEntry,
  GetOne,
} from "../../providers/dataProvider";
import { CheckNull, CurrencyConvertion, QatarConvertion } from "../../utils/Validate";
import validation from "./validation";
import { getStorageData } from "../../utils/Validate";
import { deliveryLeadTimeValues } from "../../components/common/DeliveryLeadTime";

const quotationValues = {
  quoteReference: "QT1",
  quoteType: 0,
  enquiryId: "",
  customerId: "",
  customerAddress: "",
  contactPerson: "",
  phone: "",
  emailAddress: "",
  projectId: "",
  quoteValidity: "",
  countryId: "",
  currencyId: "",
  conversionRate: "",
  salesEngineerId: "",
  advancePayment: 0,
  paymentPercentage: 0,
  paymentTermId: "",
  deliveryLeadTime: "",
  deliveryLeadTimeId: "",
  modeOfTransportId: "",
  additionalInfo: "",
  otherConditions: "",
  createdBy: localStorage.getItem("authidentity"),
  ModifiedBy: localStorage.getItem("authidentity"),
  createdAt: new Date(),
  totalListPrice: 0,
  netPrice: 0,
  specialCharges: 0,
  totalExworksPrice: 0,
  freightCharges: 0,
  customDutyPercentage: 0,
  customDuty: 0,
  clearanceChargesPercentage: 0,
  clearanceCharges: 0,
  totalLandedCost: 0,
  salesMarginPercentage: 0,
  totalSellingPrice: 0,
  taxPercentage: 0,
  tax: 0,
  grandTotal: 0,
  products: [],
  paymentTerms: "",
  destination: "",
  deliveryTerms: "",
  deliveryTermId: "",
  TenderQuoteId: "",
};

const
  useForm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [values, setValues] = useState({
      ...quotationValues,
      quoteType: location?.state?.quoteType,
    });
    const [project, setProject] = useState(null);
    const [enquiry, setEnquiry] = useState(null);
    const [quoteValidity, setQuoteValidity] = useState(null);
    const [deliveryLeadTime, setDeliveryLeadTime] = useState(null);
    const [deliveryTerms, setDeliveryTerms] = useState(null);
    const [newAddedCustomer, setNewAddedCustomer] = useState({});
    const [newAddedProject, setNewAddedProject] = useState({});

    const [quoteValidityValues, setQuoteValidityValues] = useState([
      {
        value: "10",
        label: "10 days",
      },
      {
        value: "20",
        label: "20 days",
      },
      {
        value: "30",
        label: "30 days",
      },
      {
        value: "50",
        label: "50 days",
      },
      {
        value: "60",
        label: "60 days",
      },
      {
        value: "75",
        label: "75 days",
      },
      {
        value: "90",
        label: "90 days",
      },
    ]);
    const [show, setShow] = useState(false);
    const [showNewProj, setShowNewProj] = useState(false);
    const [showNewCust, setShowNewCust] = useState(false);
    const [disabledProj, setDisabledProj] = useState(false);
    const [disabledCust, setDisabledCust] = useState(false);
    const [errorShow, setErrorShow] = useState({
      show: false,
      errorMessage: "",
    });
    const [created, setCreated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [createMsg, setCreateMsg] = useState(null);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editQuotation, setEditQuotation] = useState({
      row: null,
      id: null,
    });
    const [creditdays, setCreditDays] = useState("");
    const [advPaymentLabel, setAdvPaymentLabel] = useState(false);
    const [listData, setListData] = useState({});
    const [custList, setCustList] = useState([]);
    const [currency, setCurrency] = useState(null);
    const [projectData, setProjectData] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    const [flag, setFlag] = useState(1);
    const [customer, setCustomer] = useState(null);
    const [quotationDt, setQuotationDt] = useState(null);
    const [distributor, setDistributor] = useState("");
    const [salesEngineer, setSalesEngineer] = useState("");
    const [disableEnq, setDisableEnq] = useState(false);
    const [quoteGeneral, setQuoteGeneral] = useState(null);
    const [enquiryData, setEnquiryData] = useState([]);
    const [projectsList, setProjectList] = useState([]);
    const [customersList, setCustomerList] = useState([]);
    const [quotUserEntry, setQuotUserEntry] = useState({});
    const [currencyDetail, setCurrencyDetail] = useState({})
    const [qarCurrencyDetail, setQarCurrencyDetail] = useState({})
    const [copyStatus, setCopyStatus] = useState(null);
    const [conversionDisabled, setConversionDisabled] = useState(false);

    const { data: inquiryList } = FetchData("inquiry");
    const { data: customerList } = FetchData("Customer");
    const { data: projectList } = FetchData("project");
    const { data: distributorList } = FetchData("distributor");
    const { data: assignedEngineerList } = FetchData("userprofile");
    const { data: currencyList } = FetchData("currency");

    useEffect(() => {
      if (location?.state?.id) {
        const item = location?.state;
        GetOne("quotation", { id: item?.id }, setQuotationDt);
      }
    }, [location?.state?.id]);

    useEffect(() => {
      const userProf = getStorageData();
      const userProfId = userProf?.userCompanyId;
      if (userProf?.userType === 2) {
        const distObj = distributorList?.find(item => item?.id === userProfId);
        const isQAR = currencyList?.some(item => item?.id === distObj?.currencyId && item?.shortCode === "QAR");
        setValues({
          ...values,
          distributorId: userProfId,
          countryId: distObj?.countryId,
          currencyId: distObj?.currencyId,
          conversionRate: isQAR ? 1 : distObj?.conversionRate > 0 ? Number(distObj.conversionRate).toFixed(2) : "",
        })
        setConversionDisabled(isQAR);
      }
    }, [distributorList, currencyList])


    useEffect(() => {
      const currency = currencyList?.find(item => item?.id === values?.currencyId)
      setCurrencyDetail(currency)
    }, [values?.currencyId, currencyList])

    useEffect(() => {
      const qar = currencyList?.find(item => item?.shortCode === "QAR")
      setQarCurrencyDetail(qar)
    }, [currencyList])

    useEffect(() => {
      setQuoteGeneral(location?.state?.quotegeneral)
    }, [location?.state?.quotegeneral])

    useEffect(() => {
      setCopyStatus(location?.state?.status)
    }, [location?.state?.status])

    useEffect(() => {
      setEditQuotation({
        id: quotationDt?.data?.id,
        row: quotationDt?.data,
      });
    }, [quotationDt]);

    const HandleFormChange = (e) => {
      const { name, value } = e.target;
      if (e.target.type == "checkbox") {
        setAdvPaymentLabel(e.target.checked);
        if (e.target.checked)
          setValues({
            ...values,
            advancePayment: values?.advancePayment,
            paymentPercentage: 0,
          });
        else
          setValues({
            ...values,
            advancePayment: 0,
            paymentPercentage: values?.paymentPercentage,
          });
      } else {
        setValues({
          ...values,
          [name]: value,
        });
      }
      if (Object.keys(errors).length > 0) {
        setErrors(validation(
          {
            ...values,
            [name]: value,
          },
          salesEngineer,
          deliveryTerms
        ));
      }
    };

    useEffect(() => {
      if (projectList) setProjectList(projectList)
    }, [projectList])

    useEffect(() => {
      if (customerList) setCustomerList(customerList)
    }, [customerList])

    useEffect(() => {
      if (!editQuotation?.id) return;
      if (editQuotation?.id && projectList?.length > 0 && customerList?.length > 0 && currencyList?.length > 0) {
        const currency = currencyList?.find(item => item?.id === editQuotation?.row?.currencyId)
        const isQAR = currencyList?.some(item => item?.id === editQuotation?.row?.currencyId && item?.shortCode === "QAR");
        setConversionDisabled(isQAR);

        if (editQuotation?.row?.advancePayment > 0) setAdvPaymentLabel(true);
        setEnquiryData([
          ...inquiryList?.filter(
            (item) =>
              item?.projectId === editQuotation?.row?.projectId &&
              item?.conversionStatus === "Pending"
          ),
          ...(editQuotation?.row?.enquiryId
            ? inquiryList?.filter(
              (item) =>
                item?.id === editQuotation?.row?.enquiryId &&
                item?.conversionStatus !== "Pending"
            )
            : []),
        ]);

        setProjectData(projectsList ? projectsList : projectList?.filter((item) => item?.distributorId === editQuotation?.row?.distributorId))
        setCustomerData(customersList ? customersList : customerList?.filter((item) => item?.distributorId === editQuotation?.row?.distributorId))
        setValues({
          ...values,
          id: editQuotation?.id,
          quoteReference: editQuotation?.row?.quoteReference,
          //quoteType: editQuotation?.row?.quoteType,
          enquiryId: editQuotation?.row?.enquiryId,
          customerId: editQuotation?.row?.customerId,
          customerAddress: editQuotation?.row?.customerAddress,
          contactPerson: editQuotation?.row?.contactPerson,
          phone: editQuotation?.row?.phone,
          emailAddress: editQuotation?.row?.emailAddress,
          projectId: editQuotation?.row?.projectId,
          quoteValidity: editQuotation?.row?.quoteValidity,
          currencyId: editQuotation?.row?.currencyId,
          conversionRate: isQAR ? 1 :
            editQuotation?.row?.conversionRate > 0
              ? (editQuotation?.row?.conversionRate).toFixed(2)
              : "",
          salesEngineerId: editQuotation?.row?.salesEngineerId,
          advancePayment: editQuotation?.row?.advancePayment,
          paymentTermId: editQuotation?.row?.paymentTermId,
          deliveryLeadTime: editQuotation?.row?.deliveryLeadTime,
          deliveryLeadTimeId: editQuotation?.row?.deliveryLeadTimeId?.toString(),
          modeOfTransportId: editQuotation?.row?.modeOfTransportId * 1,
          additionalInfo: editQuotation?.row?.additionalInfo,
          otherConditions: editQuotation?.row?.otherConditions,
          modifiedBy: editQuotation?.row?.modifiedByBy,
          totalListPrice: editQuotation?.row?.totalListPrice,
          netPrice: editQuotation?.row?.netPrice,
          specialCharges: editQuotation?.row?.specialCharges,
          totalExworksPrice: editQuotation?.row?.totalExworksPrice,
          freightCharges: editQuotation?.row?.freightCharges,
          customDutyPercentage: editQuotation?.row?.customDutyPercentage,
          customDuty: editQuotation?.row?.customDuty,
          clearanceChargesPercentage: editQuotation?.row?.clearanceChargesPercentage,
          clearanceCharges: editQuotation?.row?.clearanceCharges,
          totalLandedCost: editQuotation?.row?.totalLandedCost,
          salesMarginPercentage: editQuotation?.row?.salesMarginPercentage,
          totalSellingPrice: editQuotation?.row?.totalSellingPrice,
          taxPercentage: editQuotation?.row?.taxPercentage,
          tax: editQuotation?.row?.tax,
          grandTotal: editQuotation?.row?.grandTotal,
          products: editQuotation?.row?.products,
          paymentTerms: editQuotation?.row?.paymentTerms,
          paymentPercentage: editQuotation?.row?.paymentPercentage,
          deliveryTermId: editQuotation?.row?.deliveryTermId,
          countryId: editQuotation?.row?.countryId,
          distributorId: editQuotation?.row?.distributorId,
          paymentTermId: editQuotation?.row?.paymentTermId,
          destination: editQuotation?.row?.destination,
          destinationCountryId: editQuotation?.row?.destinationCountryId,
          deliveryTerms: editQuotation?.row?.deliveryTerms,
        });
        setQuotUserEntry({
          ...quotUserEntry,
          specialCharges: CurrencyConvertion(editQuotation?.row?.specialCharges, editQuotation?.row?.conversionRate, currency),
          freightCharges: CurrencyConvertion(editQuotation?.row?.freightCharges, editQuotation?.row?.conversionRate, currency),
          customDuty: CurrencyConvertion(editQuotation?.row?.customDuty, editQuotation?.row?.conversionRate, currency),
          customDutyPercentage: editQuotation?.row?.customDutyPercentage,
          clearanceCharges: CurrencyConvertion(editQuotation?.row?.clearanceCharges, editQuotation?.row?.conversionRate, currency),
          clearanceChargesPercentage: editQuotation?.row?.clearanceChargesPercentage,
          salesMarginPercentage: editQuotation?.row?.salesMarginPercentage,
          tax: CurrencyConvertion(editQuotation?.row?.tax, editQuotation?.row?.conversionRate, currency),
          taxPercentage: editQuotation?.row?.taxPercentage
        })

        if (editQuotation?.row?.enquiryId && inquiryList?.length > 0) {
          const enqObj = inquiryList?.find(
            (ob) => ob?.id === editQuotation?.row?.enquiryId
          );
          if (enqObj) {
            setEnquiry({
              label: enqObj?.enquiryReference,
              value: enqObj?.id,
            });
          }
        }
      }
    }, [editQuotation, projectList, customerList, inquiryList, currencyList]);

    useEffect(() => {
      if (!values?.id) return;
      if (Object.keys(errors).length === 0) return;

      setErrors(validation(values, salesEngineer, deliveryTerms));
    }, [values, salesEngineer, deliveryTerms]);

    const handleSubmit = () => {
      setErrors(validation(values, salesEngineer, deliveryTerms));
      setIsSubmitting(true);
    };

    useEffect(() => {
      if (Object.keys(errors).length === 0 && isSubmitting) {
        delete values["enquiryObj"];
        if (CheckNull(values?.id) !== "") {
          setLoading(true);
          UpdateEntry(
            "quotation",
            values,
            setCreateMsg,
            "Quotation updated successfully",
            "Failed to update quotation"
          );
        } else {
          setLoading(true);
          CreateEntry(
            "quotation",
            values,
            setCreateMsg,
            "Quotation created successfully",
            "Failed to create quotation"
          );
        }
      } else {
        setIsSubmitting(false);
      }
    }, [errors]);

    useEffect(() => {
      if (CheckNull(createMsg?.message).includes("Failed")) {
        let errorsmsg = createMsg.successData;
        setErrorShow({
          show: true,
          errorMessage: errorsmsg,
        });
        setLoading(false);
      } else if (
        CheckNull(createMsg?.message) == "Quotation created successfully"
      ) {
        setShow(true);
        setCreated(false);
        setLoading(false);
      } else if (
        CheckNull(createMsg?.message) == "Quotation updated successfully"
      ) {
        setShow(true);
        setCreated(false);
        setLoading(false);
      }
    }, [createMsg]);

    const ErrorDoneClick = () => {
      setErrorShow({
        show: false,
        errorMessage: "",
      });
      setCreateMsg(null);
    };

    const SuccessDoneClick = () => {
      setShow(false);
      if (created) {
        setShowNewProj(false);
        setShowNewCust(false);
        return;
      } else if (
        CheckNull(createMsg?.message) == "Quotation created successfully"
      ) {
        const dt = createMsg?.successData;
        setEditQuotation({
          id: dt?.id,
          row: dt,
        });
      }
    };

    useEffect(() => {
      const custObj = customersList?.find(el => el?.id === newAddedCustomer?.value);
      if (!custObj) return
      setCustomerData(customersList?.filter((item) => item?.distributorId === values?.distributorId))
      setValues({
        ...values,
        customerId: newAddedCustomer?.value,
        enquiryId: "",
        customerAddress: custObj?.address,
        phone: custObj?.phone,
        emailAddress: custObj?.email,
        salesEngineerId: custObj?.assignedEngineerId,
      });
    }, [newAddedCustomer?.value, customersList]);

    useEffect(() => {
      const projObj = projectsList?.find(el => el?.id === newAddedProject?.value);
      if (!projObj) return
      setProjectData(projectsList?.filter((item) => item?.distributorId === values?.distributorId))
      setValues({
        ...values, projectId: projObj?.id
      })
    }, [newAddedProject?.value, projectsList]);

    return {
      values,
      setValues,
      projectData,
      HandleFormChange,
      handleSubmit,
      creditdays,
      setCreditDays,
      customerList,
      advPaymentLabel,
      createMsg,
      setCreateMsg,
      showNewCust,
      setShowNewCust,
      showNewProj,
      setShowNewProj,
      disabledProj,
      disabledCust,
      show,
      setShow,
      SuccessDoneClick,
      ErrorDoneClick,
      errorShow,
      setErrorShow,
      quoteValidityValues,
      quoteValidity,
      setQuoteValidity,
      deliveryLeadTimeValues,
      deliveryLeadTime,
      setDeliveryLeadTime,
      errors,
      setErrors,
      deliveryTerms,
      setDeliveryTerms,
      setDisabledCust,
      setDisabledProj,
      loading,
      setLoading,
      currency,
      inquiryList,
      enquiry,
      setEnquiry,
      flag,
      setFlag,
      editQuotation,
      setIsSubmitting,
      customer,
      setCustomer,
      project,
      setProject,
      customerData,
      distributorList,
      assignedEngineerList,
      setNewAddedCustomer,
      setCustList,
      disableEnq,
      setDisableEnq,
      distributor,
      setDistributor,
      salesEngineer,
      setSalesEngineer,
      currency,
      setCurrency,
      currencyList,
      projectList,
      setProjectData,
      quoteGeneral,
      setCustomerData,
      setNewAddedProject,
      setEnquiryData,
      enquiryData,
      projectsList,
      customersList,
      setProjectList,
      setCustomerList,
      setQuotUserEntry,
      quotUserEntry,
      currencyDetail,
      setCurrencyDetail,
      qarCurrencyDetail,
      setConversionDisabled,
      conversionDisabled,
      copyStatus
    };
  };

export default useForm;
